<template>
  <div class="headerWrapper w-full flex justify-between items-center pb-4 border-b border-gray-400 px-2">
    <slot/>
    <div 
      v-if="showSearch"
      class="pill__SearchInput InputGroupFocus w-32 ml-auto"
      ref="searchWrapper"
    >
      <input
        class="form-control"
        type="text"
        :placeholder="$t('Search')"
        :value="modelValue"
        @input="$emit('update:modelValue', $event.target.value)"
      />
      <aw-icon 
        v-if="!modelValue"
        icon="search"
      />
      <button
        v-else
        class="SearchInput__CloseIcon"
        @click.stop.prevent="eraseSearch()"
      >
        <aw-icon icon="close"/>
      </button>
    </div>
  </div>
 </template>
 
 <script>
 export default {
  props: {
    modelValue: String,
    showSearch: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['update:modelValue'],
  methods: {
    eraseSearch() {
      this.$emit('update:modelValue', null)
    },
  },
 }
 </script>

<style lang="scss" scoped>
.headerWrapper {
  margin-top: 48px;
  height: 55px;
}
</style>
